/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import theme from 'utils/theme';

/*
 * Root components of this family mount the theme themselves, so consumers do
 * not have to. Note that a MuiThemeProvider given a plain theme object
 * REPLACES the outer theme instead of merging into it, so a consumer wrapping
 * this component in mergeTheme(...) would have its overrides discarded here.
 * No consumer does that today.
 */
function SingleSelect({
    disabled,
    label,
    selectedValue,
    onChange,
    className,
    children,
    SelectProps = {},
}) {
    return (
        <MuiThemeProvider theme={theme}>
            <FormControl className={className} disabled={disabled}>
                <InputLabel shrink>{label}</InputLabel>
                <Select
                    value={selectedValue}
                    onChange={onChange}
                    displayEmpty
                    {...SelectProps}
                >
                    {children}
                </Select>
            </FormControl>
        </MuiThemeProvider>
    );
}

export default SingleSelect;
